// Environment
export const GROUND_HEIGHT = -3.7;

// Boundaries
export const LEFT_LIMIT = -5;
export const RIGHT_LIMIT = 110; // TODO: Update as more content is added
export const LEVEL_START = 60;
export const LEVEL_END = 90;
export const LASER_LIMIT = 20;
